define(function (require) {
    var $ = require("jquery");
    var utils = require("@modules/utils");

    function getAjaxPostRequest(data) {
        return {
            type: "post",
            data: data,
            dataType: "json",
            headers: {
                RequestVerificationToken: utils.getRequestVerificationToken()
            }
        };
    }

    return {
        getCounties: function (zipCode, year) {
            var parameters = {
                zipcode: zipCode,
                year: year
            };

            return $.getJSON("/api/guidedenrollment/counties", parameters).then(function (results) {
                return JSON.parse(results);
            });
        },

        getPlans: function (county, zipcode, year, language) {
            var parameters = {
                county: county,
                zipcode: zipcode,
                year: year,
                language: language
            };

            return $.getJSON("/api/guidedenrollment/plans", parameters).then(function (results) {
                return JSON.parse(results);
            });
        },

        enroll: function (parameters) {
            return $.ajax("/api/guidedenrollment/enroll", getAjaxPostRequest(parameters)).then(function (results) {
                return JSON.parse(results);
            });
        }
    };
});
